import { create } from "zustand";
import axios from "axios";

const seriesStore = create((set, get) => ({
    series: null,

    seriesForm: {
        title: "",
        overview: "",
        network: "",
        year: "",
        originalCountry: "",
        originalLanguage: "",
        numberOfSeasons: "",
        airingStatus: "",
        whereToWatch: "",
        tvdbId: "",
        genres: [],
        poster: "",
        fanart: "",
    },

    fetchSeries: async () => {
        // Fetch the series
        const res = await axios.get("/series");

        // Set to state
        set({ series: res.data.series });
    },

    tvdbSearchSeries: async (query) => {
        const res = await axios.get("/api/search", {
            params: { query }
        });

        return res.data.data?.[0];  
    },

    tvdbGetSeries: async (seriesId) => {
        const res = await axios.get(`/api/series/${seriesId}`);
        return res.data;
    },

    populateForm1: (data) => {
        try {
            set(state => ({
                seriesForm: {
                    ...state.seriesForm,
                    title: data.name || "",
                    overview: data.overview || "",
                    network: data.network || "",
                    year: data.year || "",
                    originalCountry: data.country || "",
                    originalLanguage: data.primary_language || "",
                    airingStatus: data.status || "",
                    tvdbId: data.tvdb_id || "",
                }
            }));
        } catch (err) {
            console.log("Error at populateForm1");
        }
    },

    populateForm2: (data) => {
        try {
            set(state => ({
                seriesForm: {
                    ...state.seriesForm,
                    numberOfSeasons: data.season || "", 
                    genres: data.genre || [],
                    poster: "https://artworks.thetvdb.com/banners/" + data.poster || "",
                    fanart: "https://artworks.thetvdb.com/banners/" + data.fanart || "",
                }
            }));
        } catch (err) {
            console.log("Error at populateForm2");
        }
    },


    updateSeriesForm: (e) => {
        try {
            const { name, value } = e.target;

            set(state => {
                return {
                    seriesForm: {
                    ...state.seriesForm,
                    [name]: value,
                    },
                };
            });
        } catch (err) {
            console.log("Error at updateSeriesForm");
        }
    },

    // populateSeriesFormAdd: (data) => {
    //     try {
    //         set(state => ({
    //             seriesForm: {
    //                 ...state.seriesForm,
    //                 title: data.name || "",
    //                 overview: data.overview || "",
    //                 network: data.network || "",
    //                 year: data.year || "",
    //                 originalCountry: data.country || "",
    //                 originalLanguage: data.primary_language || "",
    //                 airingStatus: data.status || "",
    //                 tvdbId: data.tvdb_id || "",
    //             }
    //         }));
    //     } catch (err) {
    //         console.log("Error at populateSeriesFormAdd");
    //     }
    // },

    // populateSeriesFormAddForEdit: (data) => {
    //     console.log("title: " + data[0].title); 
    //     try {
    //         set(state => ({
    //             seriesForm: {
    //                 ...state.seriesForm,
    //                 title: data[0].title || "",
    //                 overview: data[0].overview || "",
    //                 network: data[0].network || "",
    //                 year: data[0].year || "",
    //                 originalCountry: data[0].originalCountry || "",
    //                 originalLanguage: data[0].originalLanguage || "",
    //                 airingStatus: data[0].airingStatus || "",
    //                 tvdbId: data[0].tvdbId || "",
    //             }
    //         }));
    //     } catch (err) {
    //         console.log("Error at populateSeriesFormAddForEdit");
    //     }
    // },

    // populateSeriesFormAddForEdit2: (data) => {
    //     console.log("title: " + data.title); 
    //     try {
    //         set(state => ({
    //             seriesForm: {
    //                 ...state.seriesForm,
    //                 title: data.title || "",
    //                 overview: data.overview || "",
    //                 network: data.network || "",
    //                 year: data.year || "",
    //                 originalCountry: data.originalCountry || "",
    //                 originalLanguage: data.originalLanguage || "",
    //                 airingStatus: data.airingStatus || "",
    //                 whereToWatch: data.whereToWatch || "",
    //                 tvdbId: data.tvdbId || "",
    //             }
    //         }));
    //     } catch (err) {
    //         console.log("Error at populateSeriesFormAddForEdit2");
    //     }
    // },

    // populateSeriesFormEdit: (data) => {
    //     try {
    //         set(state => ({
    //             seriesForm: {
    //                 ...state.seriesForm,
    //                 numberOfSeasons: data.season || "", 
    //                 imageUrl: "https://artworks.thetvdb.com/banners/" + data.banner || "",
    //             }
    //         }));
    //     } catch (err) {
    //         console.log("Error at populateSeriesFormEdit");
    //     }
    // },

    createSeries: async (e) => {
        try {
            const { seriesForm } = seriesStore.getState();
            const res = await axios.post("/series", seriesForm);

            // Clear the form fields
            set({
                seriesForm: {
                    title: "",
                    overview: "",
                    network: "",
                    year: "",
                    originalCountry: "",
                    originalLanguage: "",
                    numberOfSeasons: "",
                    airingStatus: "",
                    whereToWatch: "",
                    tvdbId: "",
                    genres: [],
                    poster: "",
                    fanart: "",
                },
            });

            return res;
        } catch (err) {
            console.log("Error at createSeries");
        }
    },

    updateSeries: async (seriesId) => {
        try {
            const { seriesForm } = seriesStore.getState();
            const res = await axios.put(`/series/${seriesId}`, {seriesId: seriesId, seriesForm: seriesForm});

            // Clear the form fields
            set({
                seriesForm: {
                    title: "",
                    overview: "",
                    network: "",
                    year: "",
                    originalCountry: "",
                    originalLanguage: "",
                    numberOfSeasons: "",
                    airingStatus: "",
                    whereToWatch: "",
                    tvdbId: "",
                    genres: [],
                    poster: "",
                    fanart: "",
                },
            });
        } catch (err) {
            console.log("Error at updateSeries");
        }
    },
}));

export default seriesStore;